import { FC, useEffect, useState } from "react"
import { useDataTableStore } from "../../stores/DataTableStore"
import { useSettingsStore } from "../../stores/SettingsStore"
import { UserModel } from "../../app/modules/auth/models/UserModel"
import { exportTemplateExcel } from "../../functions/exportTemplateExcel"
import { useIntl } from "react-intl"
import useNameColumnExcel from "../../hooks/NameColumnExcel"
import { usePipelineStore } from "../../stores/PipelineStore"
import { useParams, useLocation } from "react-router-dom"
import { CustomField } from "../../interfaces/Settings"
import { useMerchantStore } from "../../stores/MerchantStore"
import { exportTemplateMerchantExcel } from "../../functions/ExportTemplateExcel/merchant"
import { exportTemplatePipelineExcel } from "../../functions/ExportTemplateExcel/pipeline"
import { exportTemplateProductExcel } from "../../functions/ExportTemplateExcel/product"
import { getCustomFieldFilteredMerchant, getCustomFieldFilteredPipeline, getCustomFieldFilteredUser } from "../../functions/ExportTemplateExcel/functionHelperExcel"
import { useUserStore } from "../../stores/UserStore"
import { exportTemplateUserExcel } from "../../functions/ExportTemplateExcel/user"
import { useGeneralStore } from "../../stores/General"
import useExcelStore from "../../stores/Excel"
import { getSelectedValueCustomFieldMeeting, getSelectedValueCustomFieldPipeline } from "../../functions/helperCustomField"
import { SimplePipeline } from "../../interfaces/Pipeline"
import { SimpleMerchant } from "../../interfaces/Merchant"
import { User } from "../../interfaces/User"
import { SimpleMeeting } from "../../interfaces/Meeting"
import { getSelectedValueCustomFieldMerchant } from "../../functions/helperCustomField"
import { useMeetingStore } from "../../stores/MeetingsStore"

interface DataTableExportTemplateProps {
    source: 'template-merchant' | 'template-user' | 'template-pipeline' | 'template-unit' | 'template-product'
    typeAction: 'insert' | 'update'
    customFields: CustomField
    user: UserModel
    param: any
    type?: string
    isOpenModalSelectCustomField: boolean
    closeModalRef: React.RefObject<HTMLButtonElement>
}

const DataTableExportTemplate: FC<DataTableExportTemplateProps> = ({ source, typeAction, user, param, type, customFields, isOpenModalSelectCustomField, closeModalRef }) => {
    const { filteredTablesData } = useDataTableStore()
    const { settings } = useSettingsStore()
    const { multiPipelines, selectMultiPipeline, simplePipelines } = usePipelineStore()
    const { multiMerchants, simpleMerchants } = useMerchantStore()
    const { simpleMeetings } = useMeetingStore()
    const [isLoading, setIsLoading] = useState(false)
    const intl = useIntl()
    const nameHeader: any = useNameColumnExcel();
    const { templatePipelineId, templateMerchantId } = useParams()
    const { getTemplateSelections } = useExcelStore()
    const [valueCustomFieldPipeline, setValueCustomFieldPipeline] = useState<SimplePipeline[]>([])
    const [valueCustomFieldMerchant, setValueCustomFieldMerchant] = useState<SimpleMerchant[]>([])
    const [valueCustomFieldMeeting, setValueCustomFieldMeeting] = useState<SimpleMeeting[]>([])
    const { users } = useUserStore()
    const { setIsCustomFieldPipeline, setIsCustomFieldMerchant, setIsCustomFieldUser, setIsCustomFieldMeeting, isCustomFieldPipeline, isCustomFieldMerchant, isCustomFieldUser, isCustomFieldMeeting, setIsOpenModalSelectCustomField } = useGeneralStore()
    const params = useParams()
    const currentIdTemplate = params['*']?.split('/')[1] || ''
    const location = useLocation()

    useEffect(() => {
        setIsCustomFieldPipeline(false);
        setIsCustomFieldMerchant(false);
        setIsCustomFieldUser(false);
        setIsCustomFieldMeeting(false);

        if (customFields && Object.keys(customFields).length > 0) {
            let hasPipeline = false;
            let hasMerchant = false;
            let hasUser = false;
            let hasMeeting = false;

            Object.keys(customFields).forEach(key => {
                if (customFields[key] && customFields[key].type === 'pipeline') {
                    hasPipeline = true;
                } else if (customFields[key] && customFields[key].type === 'merchant') {
                    hasMerchant = true;
                } else if (customFields[key] && customFields[key].type === 'user') {
                    hasUser = true;
                } else if (customFields[key] && customFields[key].type === 'meeting') {
                    hasMeeting = true;
                }
            });

            setIsCustomFieldPipeline(hasPipeline);
            setIsCustomFieldMerchant(hasMerchant);
            setIsCustomFieldUser(hasUser);
            setIsCustomFieldMeeting(hasMeeting);
        }
    }, [customFields, source, location.pathname, isOpenModalSelectCustomField]);

    useEffect(() => {
        return () => {
            setIsCustomFieldPipeline(false);
            setIsCustomFieldMerchant(false);
            setIsCustomFieldUser(false);
            setIsCustomFieldMeeting(false);
        };
    }, []);

    const getSelectedValueCustomField = () => {
        if (customFields) {
            Object.keys(customFields).forEach((key) => {
                if (customFields[key].type === 'meeting') {
                    const filteredMeetings = getSelectedValueCustomFieldMeeting(customFields, simpleMeetings, key)
                    setValueCustomFieldMeeting(filteredMeetings)
                } else if (customFields[key].type === 'merchant') {
                    const filteredMerchants = getSelectedValueCustomFieldMerchant(customFields, simpleMerchants, key)
                    setValueCustomFieldMerchant(filteredMerchants)
                } else if (customFields[key].type === 'pipeline') {
                    const filteredPipelines = getSelectedValueCustomFieldPipeline(customFields, simplePipelines, key)
                    setValueCustomFieldPipeline(filteredPipelines)
                }
            })
        }
    }

    useEffect(() => {
        getSelectedValueCustomField()
    }, [customFields, source, simpleMeetings, simpleMerchants, simplePipelines])

    const templateSelections = getTemplateSelections(currentIdTemplate) || {
        valueSelectCustomFieldPipeline: {},
        valueSelectCustomFieldMeeting: {},
        valueSelectCustomFieldMerchant: {},
        valueSelectCustomFieldUser: {},
        valueSelectMerchants: []
    };

    const handleButton = (typeBtn: string) => {
        setIsLoading(true)
        if (source === 'template-merchant') {
            const filteredCustomFieldMerchant = getCustomFieldFilteredMerchant(templateMerchantId as string, multiMerchants, user!)

            if (typeAction === 'insert') {
                if (typeBtn === 'error') setTimeout(() => exportTemplateMerchantExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_ERROR' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.ADD' }), title2: settings.merchant_title }),
                    customFields: filteredCustomFieldMerchant,
                    source,
                    typeAction,
                    settings,
                    nameInfo: `Template Error Insert Merchant ${templateMerchantId}`,
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline || valueCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting || valueCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant || valueCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user!,
                    param,
                    type,
                    intl
                }), 100)
                else setTimeout(() => exportTemplateMerchantExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.ADD' }), title2: settings.merchant_title }),
                    customFields: filteredCustomFieldMerchant,
                    source,
                    typeAction,
                    settings,
                    nameInfo: `Template Insert Merchant ${templateMerchantId}`,
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline || valueCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting || valueCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant || valueCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param,
                    type,
                    intl
                }), 100)
            } else if (typeAction === 'update') {
                if (typeBtn === 'error') setTimeout(() => exportTemplateMerchantExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_ERROR' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.UPDATE' }), title2: settings.merchant_title }),
                    customFields: filteredCustomFieldMerchant,
                    source,
                    typeAction,
                    settings,
                    nameInfo: `Template Error Update Merchant ${templateMerchantId}`,
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline || valueCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting || valueCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant || valueCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param,
                    type,
                    intl
                }), 100)
                else setTimeout(() => exportTemplateMerchantExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_ERROR' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.UPDATE' }), title2: settings.merchant_title }),
                    customFields: filteredCustomFieldMerchant,
                    source,
                    typeAction,
                    settings,
                    nameInfo: `Template Error Update Merchant ${templateMerchantId}`,
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline || valueCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting || valueCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant || valueCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param: { ...param, dataTables: filteredTablesData[`merchants`] },
                    type,
                    intl
                }), 100)
            }
        } else if (source === 'template-user') {
            const filteredCustomFieldUser = getCustomFieldFilteredUser(customFields)

            if (typeAction === 'insert') {
                if (typeBtn === 'error') setTimeout(() => exportTemplateUserExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_ERROR' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.ADD' }), title2: intl.formatMessage({ id: 'FORM.LABEL.USER' }) }),
                    customFields: filteredCustomFieldUser,
                    source,
                    typeAction,
                    settings,
                    nameInfo: 'Template Error Insert User',
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline || valueCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting || valueCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant || valueCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param,
                    type,
                    intl
                }), 100)
                else setTimeout(() => exportTemplateUserExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.ADD' }), title2: intl.formatMessage({ id: 'FORM.LABEL.USER' }) }),
                    customFields: filteredCustomFieldUser,
                    source,
                    typeAction,
                    settings,
                    nameInfo: 'Template Insert User',
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline || valueCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting || valueCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant || valueCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param,
                    type,
                    intl
                }), 100)
            } else if (typeAction === 'update') {
                if (typeBtn === 'error') setTimeout(() => exportTemplateUserExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.ADD' }), title2: intl.formatMessage({ id: 'FORM.LABEL.USER' }) }),
                    customFields: filteredCustomFieldUser,
                    source,
                    typeAction,
                    settings,
                    nameInfo: 'Template Insert User',
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline || valueCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting || valueCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant || valueCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param,
                    type,
                    intl
                }), 100)
                else setTimeout(() => exportTemplateUserExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.UPDATE' }), title2: intl.formatMessage({ id: 'FORM.LABEL.USER' }) }),
                    customFields: filteredCustomFieldUser,
                    source,
                    typeAction,
                    settings,
                    nameInfo: 'Template Error Update User',
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline || valueCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting || valueCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant || valueCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param: { ...param, dataTables: filteredTablesData['users'] },
                    type,
                    intl
                }), 100)
            }
        } else if (source === 'template-pipeline') {
            const filteredCustomFieldPipeline = getCustomFieldFilteredPipeline(templatePipelineId as string, multiPipelines, user!)

            if (typeAction === 'insert') {
                if (typeBtn === 'error') setTimeout(() => exportTemplatePipelineExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_ERROR' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.ADD' }), title2: settings.pipeline_title + "-" + selectMultiPipeline.name }),
                    customFields: filteredCustomFieldPipeline,
                    source,
                    typeAction,
                    settings,
                    nameInfo: `Template Error Insert Pipeline ${templatePipelineId}`,
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline || valueCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting || valueCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant || valueCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param,
                    type,
                    dataMerchants: templateSelections.valueSelectMerchants || simpleMerchants,
                    intl
                }), 100)
                else setTimeout(() => exportTemplatePipelineExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.ADD' }), title2: settings.pipeline_title + "-" + selectMultiPipeline.name }),
                    customFields: filteredCustomFieldPipeline,
                    source,
                    typeAction,
                    settings,
                    nameInfo: `Template Insert Pipeline ${templatePipelineId}`,
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline || valueCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting || valueCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant || valueCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param,
                    type,
                    dataMerchants: templateSelections.valueSelectMerchants || simpleMerchants, 
                    intl
                }), 100)
            } else if (typeAction === 'update') {
                if (typeBtn === 'error') setTimeout(() => exportTemplatePipelineExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_ERROR' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.UPDATE' }), title2: settings.pipeline_title }),
                    customFields: filteredCustomFieldPipeline,
                    source,
                    typeAction,
                    settings,
                    nameInfo: `Template Error Update Pipeline ${templatePipelineId}`,
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline || valueCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting || valueCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant || valueCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param: { ...param, dataTables: filteredTablesData['pipeline'] },
                    type,
                    dataMerchants: templateSelections.valueSelectMerchants || simpleMerchants,
                    intl
                }), 100)
                else setTimeout(() => exportTemplatePipelineExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.UPDATE' }), title2: settings.pipeline_title }),
                    customFields: filteredCustomFieldPipeline,
                    source,
                    typeAction,
                    settings,
                    nameInfo: `Template Update Pipeline ${templatePipelineId}`,
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline || valueCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting || valueCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant || valueCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param: { ...param, dataTables: filteredTablesData['pipeline'] },
                    type,
                    dataMerchants: templateSelections.valueSelectMerchants || simpleMerchants,
                    intl
                }), 100)
            }
        } else if (source === 'template-unit') {
            if (typeAction === 'insert') {
                if (typeBtn === 'error') setTimeout(() => exportTemplateExcel(intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_ERROR' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.ADD' }), title2: intl.formatMessage({ id: 'FORM.LABEL.UNITS' }) }), source, typeAction, settings, 'Template Error Insert Unit', nameHeader.import, setIsLoading, user, param, type), 100)
                else setTimeout(() => exportTemplateExcel(intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.ADD' }), title2: intl.formatMessage({ id: 'FORM.LABEL.UNITS' }) }), source, typeAction, settings, 'Template Insert Unit', nameHeader.import, setIsLoading, user, param), 100)
            } else if (typeAction === 'update') {
                if (typeBtn === 'error') setTimeout(() => exportTemplateExcel(intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_ERROR' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.UPDATE' }), title2: intl.formatMessage({ id: 'FORM.LABEL.UNITS' }) }), source, typeAction, settings, 'Template Error Update Unit', nameHeader.import, setIsLoading, user, param, type), 100)
                else setTimeout(() => exportTemplateExcel(intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.UPDATE' }), title2: intl.formatMessage({ id: 'FORM.LABEL.UNITS' }) }), source, typeAction, settings, 'Template Update Unit', nameHeader.import, setIsLoading, user, { ...param, dataTables: filteredTablesData['units'] }), 100)
            }
        } else if (source === 'template-product') {
            if (typeAction === 'insert') {
                setTimeout(() => exportTemplateProductExcel({
                    nameFile: `${typeBtn === 'error' ? intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_ERROR' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.ADD' }), title2: intl.formatMessage({ id: 'FORM.MENU.PRODUCTS' }) }) : intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.ADD' }), title2: intl.formatMessage({ id: 'FORM.MENU.PRODUCTS' }) })}`,
                    nameInfo: `${typeBtn === 'error' ? 'Template Error Insert Product' : 'Template Insert Product'}`,
                    nameHeader: nameHeader.import,
                    source,
                    typeAction,
                    user: user!,
                    param,
                    type: type!,
                    setIsLoading
                }), 100)
            } else if (typeAction === 'update') {
                setTimeout(() => exportTemplateProductExcel({
                    nameFile: `${typeBtn === 'error' ? intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_ERROR' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.UPDATE' }), title2: intl.formatMessage({ id: 'FORM.MENU.PRODUCTS' }) }) : intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.UPDATE' }), title2: intl.formatMessage({ id: 'FORM.MENU.PRODUCTS' }) })}`,
                    nameInfo: `${typeBtn === 'error' ? 'Template Error Update Product' : 'Template Update Product'}`,
                    nameHeader: nameHeader.import,
                    source,
                    typeAction,
                    user: user!,
                    param: { ...param, dataTables: filteredTablesData['products'] },
                    type: type!,
                    setIsLoading
                }), 100)
            }
        }
    }

    if (type === 'error') {
        return (
            <button
                type="button"
                className={`btn btn-light-danger skeleton skeleton-button mb-3 w-100 ${isLoading ? 'disabled' : ""}`}
                data-kt-indicator={isLoading ? 'on' : 'off'}
                id="optionImport"
                onClick={() => handleButton('error')}
            >
                <i className="fas fa-file-download fs-2 me-2"></i>
                <span className="indicator-label">
                    {intl.formatMessage({ id: 'FORM.ACTION.DOWNLOAD_TEMPLATE_ERROR' })}
                </span>
                <span className="indicator-progress">
                    Loading... &nbsp;
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
            </button>
        )
    } else {
        return (
            <button
                type="button"
                className={`btn btn-success skeleton skeleton-button mb-3 w-100 ${isLoading ? 'disabled' : ""}`}
                data-kt-indicator={isLoading ? 'on' : 'off'}
                id="optionImport"
                onClick={() => {
                    if (isCustomFieldPipeline || isCustomFieldMerchant || isCustomFieldUser || isCustomFieldMeeting) {
                        setIsOpenModalSelectCustomField(true)
                        closeModalRef.current?.click()
                    } else if (source === 'template-pipeline') {
                        setIsOpenModalSelectCustomField(true)
                        closeModalRef.current?.click()
                    } else {
                        handleButton('success')
                    }
                }}
            >
                <i className="fas fa-file-download fs-2 me-2"></i>
                <span className="indicator-label">
                    {intl.formatMessage({ id: 'FORM.ACTION.DOWNLOAD_TEMPLATE' })}
                </span>
                <span className="indicator-progress">
                    Loading... &nbsp;
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
            </button>
        )
    }
}

export { DataTableExportTemplate }